module.exports = {"623001001":"当周街道","623001002":"伊合昂街道","623001003":"坚木克尔街道","623001004":"通钦街道","623001200":"卡加曼乡","623001201":"卡加道乡","623001202":"佐盖多玛乡","623001203":"佐盖曼玛乡","623001204":"勒秀乡","623001205":"那吾乡","623001400":"甘南州综合实验场","623001401":"合作市苗圃"}


//////////////////
// WEBPACK FOOTER
// ./src/town/623001.json
// module id = 2758
// module chunks = 0